import { Box, IconButton, InputAdornment, Modal, Skeleton, TextField, Theme, Typography, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { CustomeButton } from '../../../lib/formik/NewFormInputs';
import { DialogCloseIcon, SearchIcon } from '../../../assets/SvgIcons';
import { Order, PaginationObj, SortingObj, TableBodyData, TableHeaderData } from '../types';
import CustomTable from './customTable';
import MutualFundTableBody from './customTable/MutualFundTableBody';
import { HoldingModalTableBody, InvestmentSearchTable, InvestmentSearchTableResponsive } from '../mutualFund/common/Table';
import { useDispatch, useSelector } from 'react-redux';
import { getSearchSchemesTableData, setSelectedHoldingsIds, setSelectedSchemesObj } from '../../../redux-store/actions/investorProfile';
import { useDebounce } from '../../../utils/useDebounce';
import { GetSearchSchemesTableDataResponseBody } from '../../../redux-store/types/investorProfile';
import { useHistory } from 'react-router';
import FiveSchemesDialog from '../exploreMutualFund/FiveSchemesDialog';
import { RootStateType } from '../../../redux-store/reducers';
const tableDatas = [
    {
        id: 1,
        mutualfund: {
            name: 'DSP Short Term Fund Growth Plan',
            type: 'Equity',
            cap: 'Large Cap',
            risk: 'Very high risk',
            risklevel: 3,
            image:
                'https://s3-alpha-sig.figma.com/img/b881/5771/80648be305b04aee802e2983ee32eb71?Expires=1713139200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Jm9LVFjpGg~9XKP1l3XSB8dPbLVZBXttKfjD9TpcXqRN4F9wX0oeUa1NWC8xRRT53oMGROUqfbxsR8B-s2mr7lzBeyIrHr4Bvm-zyyMWilFMEuIq-BIH5NoNZWM3IhNSPR8tb0ZAOO33KMeR0FwF~cDj1nwAWTk0MMmwf20p3109y8ixN~Z643ap3G1ERoLzM6YRBTyRfP7hsOy2wCh4WOA1aDMSvuLAEsfXaO2PSck2iet6aaJ67ZIHOl6SOpJfckePZMh17eEBaUEpVAkWBZuEFvvZWoDxPjuiSsk3rmu8oRk5ohI-FbBprcubGK2oYuYiMWYv0e8VcRden8YwZw__',
        },
        unit: 50,
        invested: 10000,
        market: 20000,
    },
    {
        id: 2,
        mutualfund: {
            name: 'DSP Short Term Fund Growth Plan',
            type: 'Equity',
            cap: 'Large Cap',
            risk: 'Very high risk',
            risklevel: 3,
            image:
                'https://s3-alpha-sig.figma.com/img/b881/5771/80648be305b04aee802e2983ee32eb71?Expires=1713139200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Jm9LVFjpGg~9XKP1l3XSB8dPbLVZBXttKfjD9TpcXqRN4F9wX0oeUa1NWC8xRRT53oMGROUqfbxsR8B-s2mr7lzBeyIrHr4Bvm-zyyMWilFMEuIq-BIH5NoNZWM3IhNSPR8tb0ZAOO33KMeR0FwF~cDj1nwAWTk0MMmwf20p3109y8ixN~Z643ap3G1ERoLzM6YRBTyRfP7hsOy2wCh4WOA1aDMSvuLAEsfXaO2PSck2iet6aaJ67ZIHOl6SOpJfckePZMh17eEBaUEpVAkWBZuEFvvZWoDxPjuiSsk3rmu8oRk5ohI-FbBprcubGK2oYuYiMWYv0e8VcRden8YwZw__',
        },
        unit: 50,
        invested: 10000,
        market: 20000,
    },
    {
        id: 3,
        mutualfund: {
            name: 'DSP Short Term Fund Growth Plan',
            type: 'Equity',
            cap: 'Large Cap',
            risk: 'Very high risk',
            risklevel: 3,
            image:
                'https://s3-alpha-sig.figma.com/img/b881/5771/80648be305b04aee802e2983ee32eb71?Expires=1713139200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Jm9LVFjpGg~9XKP1l3XSB8dPbLVZBXttKfjD9TpcXqRN4F9wX0oeUa1NWC8xRRT53oMGROUqfbxsR8B-s2mr7lzBeyIrHr4Bvm-zyyMWilFMEuIq-BIH5NoNZWM3IhNSPR8tb0ZAOO33KMeR0FwF~cDj1nwAWTk0MMmwf20p3109y8ixN~Z643ap3G1ERoLzM6YRBTyRfP7hsOy2wCh4WOA1aDMSvuLAEsfXaO2PSck2iet6aaJ67ZIHOl6SOpJfckePZMh17eEBaUEpVAkWBZuEFvvZWoDxPjuiSsk3rmu8oRk5ohI-FbBprcubGK2oYuYiMWYv0e8VcRden8YwZw__',
        },
        unit: 50,
        invested: 10000,
        market: 20000,
    },
    {
        id: 4,
        mutualfund: {
            name: 'DSP Short Term Fund Growth Plan',
            type: 'Equity',
            cap: 'Large Cap',
            risk: 'Very high risk',
            risklevel: 3,
            image:
                'https://s3-alpha-sig.figma.com/img/b881/5771/80648be305b04aee802e2983ee32eb71?Expires=1713139200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Jm9LVFjpGg~9XKP1l3XSB8dPbLVZBXttKfjD9TpcXqRN4F9wX0oeUa1NWC8xRRT53oMGROUqfbxsR8B-s2mr7lzBeyIrHr4Bvm-zyyMWilFMEuIq-BIH5NoNZWM3IhNSPR8tb0ZAOO33KMeR0FwF~cDj1nwAWTk0MMmwf20p3109y8ixN~Z643ap3G1ERoLzM6YRBTyRfP7hsOy2wCh4WOA1aDMSvuLAEsfXaO2PSck2iet6aaJ67ZIHOl6SOpJfckePZMh17eEBaUEpVAkWBZuEFvvZWoDxPjuiSsk3rmu8oRk5ohI-FbBprcubGK2oYuYiMWYv0e8VcRden8YwZw__',
        },
        unit: 50,
        invested: 10000,
        market: 20000,
    },
    {
        id: 5,
        mutualfund: {
            name: 'DSP Short Term Fund Growth Plan',
            type: 'Equity',
            cap: 'Large Cap',
            risk: 'Very high risk',
            risklevel: 3,
            image:
                'https://s3-alpha-sig.figma.com/img/b881/5771/80648be305b04aee802e2983ee32eb71?Expires=1713139200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Jm9LVFjpGg~9XKP1l3XSB8dPbLVZBXttKfjD9TpcXqRN4F9wX0oeUa1NWC8xRRT53oMGROUqfbxsR8B-s2mr7lzBeyIrHr4Bvm-zyyMWilFMEuIq-BIH5NoNZWM3IhNSPR8tb0ZAOO33KMeR0FwF~cDj1nwAWTk0MMmwf20p3109y8ixN~Z643ap3G1ERoLzM6YRBTyRfP7hsOy2wCh4WOA1aDMSvuLAEsfXaO2PSck2iet6aaJ67ZIHOl6SOpJfckePZMh17eEBaUEpVAkWBZuEFvvZWoDxPjuiSsk3rmu8oRk5ohI-FbBprcubGK2oYuYiMWYv0e8VcRden8YwZw__',
        },
        unit: 50,
        invested: 10000,
        market: 20000,
    },
];

export const HoldingModalTableHead: TableHeaderData[] = [
    {
        id: 'schemeName',
        label: 'SCHEME',
        align: 'left',
        isSortable: true,
    },
    {
        id: "intFundRating",
        label: "Ratings",
        align: "center",
        isSortable: true
    },
    {
        id: 'year1Return',
        label: '1Y Return',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'year3Return',
        label: '3Y Return',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'year5Return',
        label: '5Y Return',
        align: 'center',
        isSortable: true,
    },
];

type Props = {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    clientCode?: string;
    handleAddMoreProceed: () => void
    handleAddMoreChangeRadion: (data: any) => void
    radioValue: any[]
    setRadioValue: React.Dispatch<React.SetStateAction<any[]>>
    setWarning: React.Dispatch<React.SetStateAction<boolean>>
    warning: boolean
    setSchemeAllDetails?: React.Dispatch<React.SetStateAction<any[]>>
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '1000px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    borderRadius: '25px',
    boxShadow: 24,
    p:{xs:"15px 15px 30px 15px",sm:'35px'},
    ':focus': {
        outline: 'none',
    },
    height: 'fit-content',
    maxHeight: '90vh',
    // overflowY: 'auto',
};

function calculateRowsPerPageOptions(totalItemCount: number): number[] {
    const defaultOptions = [5, 10, 20, 30]; // Default options
    const availableOptions: number[] = [];

    // Loop through default options and check if they fit within totalItemCount
    for (const option of defaultOptions) {
        if (option <= totalItemCount) {
            availableOptions.push(option);
        } else {
            // If the option exceeds totalItemCount, break the loop
            break;
        }
    }

    // If no options fit within totalItemCount, use the smallest default option
    if (availableOptions.length === 0) {
        availableOptions.push(defaultOptions[0]);
    }

    return availableOptions;
}

const list = ['All', 'Equity', 'Debt', 'Hybrid', 'Others'];

const listMap: { [key: string]: string } = {
    'All': '',
    'Equity': '1',
    'Debt': '2',
    'Hybrid': '3',
    'Others': '4',
}

const MoreFundsModal = (props: Props) => {
    const { open, setOpen, clientCode, handleAddMoreProceed, handleAddMoreChangeRadion, radioValue, setRadioValue, setWarning, warning, setSchemeAllDetails } = props;
    const { palette } = useTheme();
    const dispatch = useDispatch();
    const history = useHistory()
    const { state, pathname } = history.location
    const {
        selectedSchemesObj = {},
        selectedHoldingsIds
    } = useSelector((store: RootStateType) => store.investorProfile);

    const ReduxFormData = useSelector((store: RootStateType) => store.investmentFormData);

    const selectedSchemes = (state as { selectedSchemes?: string[] })?.selectedSchemes ?? []


    const [isLoading, setIsLoading] = useState<boolean>(false)
    // const [radioValue, setRadioValue] = useState<any[]>([]);
    //table data
    const [searchInput, setSearchInput] = useState('');
    const [currentCategory, setCurrentCategory] = useState<string>("All");
    const [tableData, setTableData] = useState<TableBodyData[]>([])
    const [tableSortingObj, setTableSortingObj] = useState<SortingObj>({
        order: "desc",
        orderBy: "year3Return"
    })
    const [tablePaginationObj, setTablePaginationObj] = useState<PaginationObj>({
        currentPage: 0,
        rowsPerPage: 5,
        totalRows: 0,
    })
    const [rowsPerPageOptions, setRowsPerPageOptions] = useState<number[]>([5])
    const [initialData, setInitialData] = useState<any[]>(selectedSchemes) //  this data for cancellation perpose
    // const [warning, setWarning] = useState<boolean>(false);

    const debounceSearchText = useDebounce(searchInput, 500);

    useEffect(() => {

        setRadioValue(selectedSchemes)

    }, [selectedSchemes, open])

    useEffect(() => {
        const fetchApi = async () => {
            setIsLoading(true)
            const payload = {
                searchInput: debounceSearchText,
                category: '',
                currentPage: tablePaginationObj.currentPage,
                fundsPerPage: tablePaginationObj.rowsPerPage,
                sort: tableSortingObj.orderBy,
                order: tableSortingObj.order, //"asc" "desc"
            };
            const res: { totalLength: number, currentPageFunds: TableBodyData[] } = await dispatch(getSearchSchemesTableData(payload)) as unknown as { totalLength: number, currentPageFunds: TableBodyData[] };
            setTableData(res.currentPageFunds)
            setRowsPerPageOptions(calculateRowsPerPageOptions(res.totalLength))
            setTablePaginationObj({
                currentPage: 0,
                rowsPerPage: 5,
                totalRows: res.totalLength,
            })
            setIsLoading(false)
        };
        fetchApi();
    }, [debounceSearchText]);

    // const handleChangeRadion = (data: any) => {
    //     setRadioValue(((pre: any) => {

    //         const remining = pre.filter((item: any) => (item?.scheme || item) === data.scheme)

    //         if (pre.length >= 5 && !remining.length) {
    //             setWarning(true)
    //             return pre
    //         }
    //         if (remining.length === 0) {
    //             return [...pre, data]
    //         } else if (remining.length > 0) {
    //             return pre.filter((item: any) => (item?.scheme || item) !== data.scheme)
    //         }
    //     }));
    // };

    const handleTablePageChange = async (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {

        // console.log('page', page)
        try {
            setIsLoading(true)

            const payload = {
                searchInput: debounceSearchText,
                category: listMap[currentCategory],
                currentPage: page + 1,
                fundsPerPage: tablePaginationObj.rowsPerPage,
                sort: tableSortingObj.orderBy,
                order: tableSortingObj.order
            }

            const { totalLength = 0, currentPageFunds = [] } = await (dispatch(getSearchSchemesTableData(payload)) as unknown as Promise<GetSearchSchemesTableDataResponseBody>)

            setTableData(currentPageFunds)
            setTablePaginationObj(prevState => ({
                ...prevState,
                currentPage: page,
                totalRows: totalLength
            }))
        } catch (e) {
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }

    const handleTableRowsPerPageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log(event.target.value)
        setTablePaginationObj((prevState) => ({ ...prevState, currentPage: 0, rowsPerPage: Number(event.target.value) }))
        try {
            setIsLoading(true)

            const payload = {
                searchInput: debounceSearchText,
                category: listMap[currentCategory],
                currentPage: 1,
                fundsPerPage: Number(event.target.value),
                sort: tableSortingObj.orderBy,
                order: tableSortingObj.order
            }

            const { totalLength = 0, currentPageFunds = [] } = await (dispatch(getSearchSchemesTableData(payload)) as unknown as Promise<GetSearchSchemesTableDataResponseBody>)

            setTableData(currentPageFunds)
            setTablePaginationObj({
                currentPage: 0,
                rowsPerPage: Number(event.target.value),
                totalRows: totalLength
            })
        } catch (e) {
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }

    const handleTableSort = async (orderBy: string, order: Order) => {
        // setTableSortingObj({ orderBy, order })
        try {
            setIsLoading(true)

            const payload = {
                searchInput: debounceSearchText,
                category: listMap[currentCategory],
                currentPage: tablePaginationObj.currentPage + 1,
                fundsPerPage: tablePaginationObj.rowsPerPage,
                sort: orderBy,
                order: order
            }

            const { totalLength = 0, currentPageFunds = [] } = await (dispatch(getSearchSchemesTableData(payload)) as unknown as Promise<GetSearchSchemesTableDataResponseBody>)

            setTableData(currentPageFunds)
            setTableSortingObj({
                order,
                orderBy
            })
            // setTablePaginationObj({
            //     currentPage: 0,
            //     rowsPerPage: 5,
            //     totalRows: totalLength
            // })
        } catch (e) {
            console.log(e)
        } finally {
            setIsLoading(false)
        }

    }

    const handleCategoryChange = async (item: string) => {
        // setCurrentCategory(item)
        try {
            setIsLoading(true)

            setCurrentCategory(item)

            setTableSortingObj({
                order: "desc",
                orderBy: "year3Return"
            })

            const payload = {
                searchInput: debounceSearchText,
                category: listMap[item],
                currentPage: 1,
                fundsPerPage: 5,
                sort: "year3Return",
                order: "desc"
            }

            const { totalLength = 0, currentPageFunds = [] } = await (dispatch(getSearchSchemesTableData(payload)) as unknown as Promise<GetSearchSchemesTableDataResponseBody>)

            setTableData(currentPageFunds)
            setTablePaginationObj({
                currentPage: 0,
                rowsPerPage: 5,
                totalRows: totalLength
            })
        } catch (e) {
            console.log("Error:", e)
        } finally {
            setIsLoading(false)
        }
    }

    // console.log('pathname', pathname.split('/')[pathname.split('/').length - 1])
    // const handleProceed = () => {
    //     if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {

    //         history.replace({ state: ({ selectedSchemes: radioValue.map((obj: any) => (obj?.scheme || obj)), clientCode }) })

    //         dispatch(setSelectedHoldingsIds(radioValue.map((obj: any) => (obj?.scheme || obj))))


    //     } else {
    //         history.replace({ state: ({ selectedSchemes: radioValue, clientCode }) })

    //         const selectedSchemesObj = radioValue.reduce((acc: any, obj: any) => {
    //             acc[obj.scheme] = {
    //                 ...obj,
    //                 scheme: `${obj.scheme}`,
    //                 checked: obj.checked ? obj.checked : true,
    //             };
    //             return acc;
    //         }, {});


    //         dispatch(setSelectedSchemesObj(selectedSchemesObj))

    //     }


    //     setOpen(false);
    // }

    return (
        <>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby={'All Schemes'}
                aria-describedby={'All Schemes'}>
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '10px',
                        }}>
                        <Typography variant="h1">All Schemes</Typography>
                        <Box maxWidth={'225px'} width={'100%'}>
                            <CustomeButton lookType={'contained'} btnText={'Proceed'} onClick={handleAddMoreProceed} />
                        </Box>
                    </Box>
                    <TextField
                        autoFocus
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        sx={{
                                            display: searchInput.length > 0 ? 'inline-flex' : 'none',
                                        }}
                                        onClick={() => setSearchInput('')}
                                    >
                                        <DialogCloseIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx: (theme: Theme) => ({
                                borderRadius: '57px',
                                height: '47.17px',
                                border: `1px solid ${theme.palette.text.secondary}B2`,
                                marginTop: '20px',
                                '& fieldset': {
                                    border: 'none',
                                },
                                '& input': {
                                    paddingLeft: '10px',
                                    ...theme.typography.body_500,
                                    color: theme.palette.text.primary,
                                    '::placeholder': {
                                        ...theme.typography.subtitle_400,
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }),
                        }}
                        placeholder="Search for Mutual Funds..."
                        value={searchInput}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setSearchInput(event.target.value);
                        }}
                    />
                    {/* </Box> */}

                    <Box marginTop={'25px'} display={'flex'} flexDirection={'row'} gap={{xs:"5px",sm:"10px"}}>
                        {list.map((item, index) => (
                            <Box
                                component={'button'}
                                sx={{
                                    background: currentCategory === item ? palette.primary[500] : 'transparent',
                                    padding: '10px 15px',
                                    borderRadius: '10px',
                                    border: 'none',
                                    cursor: 'pointer',
                                }}
                                key={index}
                                onClick={() => handleCategoryChange(item)}>
                                <Typography
                                    variant="body_500"
                                    color={item === currentCategory ? palette.textDark.primary : palette.text.secondary}>
                                    {item}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    <Box component={'div'} width={'100%'} maxWidth={'993px'} marginTop={'25px'} height={{ xs: "45vh", sm: "70%" }} overflow={'auto'}>
                        {/* {isLoading &&
                            <Box display={'flex'} flexDirection={'column'} gap={'30px'} mt={'55px'}>
                                {[...Array(tablePaginationObj.rowsPerPage)].map((item, index) => (
                                    <Skeleton
                                        key={index}
                                        variant="rectangular"
                                        width={'100%'}
                                        animation="wave"
                                        height={'60px'}
                                        sx={{
                                            borderRadius: '10px',
                                        }}
                                    />
                                ))}
                            </Box>
                        } */}
                        {/* {!isLoading && */}
                        <CustomTable
                            loadingRowsNum={tablePaginationObj.rowsPerPage}
                            isLoading={isLoading}
                            tableBody={
                                <InvestmentSearchTable
                                    tableBodyData={tableData || []}
                                    radioValue={radioValue}
                                    handleRatioClick={handleAddMoreChangeRadion}
                                    selectedSchemesIds={selectedSchemes}
                                />
                            }
                            tableData={tableData || []}
                            tableBodyLoaderRowCustomStyles={{
                                '& td:first-of-type': {
                                    paddingLeft: '0px',
                                },
                            }}
                            tableHeaderData={HoldingModalTableHead}
                            tableHeadRowCustomStyles={{
                                '& th:first-of-type': {
                                    paddingLeft: '0px',
                                },
                            }}

                            handleSort={handleTableSort}
                            tableBodyCustomStyles={{
                                '& tr:last-child td': {
                                    border: 0,
                                },
                            }}
                            tableContainerStyles={{
                                height: '100%',
                                maxHeight: 'calc(100vh - 450px)',
                                minHeight: '350px',
                                overflowY: 'auto',
                            }}
                            handlePageChange={handleTablePageChange}
                            handleRowsPerPageChange={handleTableRowsPerPageChange}
                            tableDataCount={tablePaginationObj.totalRows || 0}
                            isPaginationVisible={true}
                            rowsPerPageOptions={rowsPerPageOptions}
                            rowsPerPage={tablePaginationObj.rowsPerPage}
                            currentPage={tablePaginationObj.currentPage}
                            order={tableSortingObj.order}
                            orderBy={tableSortingObj.orderBy}
                            manualResponsiveBody={true}
                            hideResponsiveHeader={true}
                            ManualResponsiveBodyComponent={
                                <InvestmentSearchTableResponsive
                                    tableBodyData={tableData || []}
                                    handleRatioClick={handleAddMoreChangeRadion}
                                    radioValue={radioValue}
                                    tableHeaderData={HoldingModalTableHead}
                                    selectedSchemesIds={selectedSchemes}
                                />
                            }
                            paginationStyles={{
                                marginRight: 0,
                                background: 'white',
                                position: 'absolute',
                                bottom: -20,
                                left: 0,
                                width: '100%',
                                '& .MuiTablePagination-selectLabel': {
                                    marginTop: '5px',
                                    marginBottom: '5px'
                                }
                            }}
                            headSticky
                            isScrollTable
                        />
                        {/* } */}
                    </Box>
                </Box>
            </Modal>
            <FiveSchemesDialog isVisible={warning} onClose={() => setWarning(false)} />
        </>
    );
};

export default MoreFundsModal;
